import { render, staticRenderFns } from "./CDataTableFixed.vue?vue&type=template&id=7dadf27a&scoped=true"
import script from "./CDataTableFixed.vue?vue&type=script&lang=js"
export * from "./CDataTableFixed.vue?vue&type=script&lang=js"
import style0 from "./CDataTableFixed.vue?vue&type=style&index=0&id=7dadf27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dadf27a",
  null
  
)

export default component.exports